/**
 * Is the viewport at least this wide, right now?
 *
 * Tailwind's `lg:` prefix handles nearly everything, but not "render this in a
 * different place". The Front Desk chat has to live inside the top bar on a
 * phone and float free on a desktop, and it cannot do both from one mount
 * point: the header carries `backdrop-blur`, which makes it the containing
 * block for anything `position: fixed` inside it. A fixed button in there pins
 * itself to the header, not the window.
 */
import { useEffect, useState } from "react";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Tailwind's `lg` breakpoint, which is where the side nav appears. */
export const LG = "(min-width: 1024px)";
